import { GeneralLimitCallout } from './GeneralLimitCallout';
import { StatusByCategoryLimitCallout } from './StatusByCategoryLimitCallout';
import { StatusByRequestLimitCallout } from './StatusByRequestLimitCallout';

type Props = {
  className?: string;
  requestDate?: Date;
  requestAmount?: number;
  originalRequestAmount?: number;
  expenseCategoryId?: string;
  requestId?: string;
  currency: string;
  setReimbursedAmount?: (reimbursedAmount: number) => void;
};

export const SpendLimitCallout = ({
  className,
  requestDate,
  requestAmount,
  originalRequestAmount,
  expenseCategoryId,
  requestId,
  currency,
  setReimbursedAmount,
}: Props) => {
  const shouldRenderGeneralLimitCallout =
    Boolean(expenseCategoryId) && (!requestDate || !requestAmount);
  const shouldRenderStatusByRequestLimitCallout =
    Boolean(requestId) &&
    Boolean(requestAmount) &&
    Boolean(requestDate) &&
    !expenseCategoryId;
  const shouldRenderStatusByCategoryLimitCallout =
    Boolean(expenseCategoryId) &&
    Boolean(requestDate) &&
    Boolean(requestAmount);

  const renderGeneralLimitCallout = () => {
    if (!expenseCategoryId) {
      return null;
    }
    return (
      <div className={className}>
        <GeneralLimitCallout
          expenseCategoryId={expenseCategoryId}
          className={className}
        />
      </div>
    );
  };

  const renderStatusByRequestLimitCallout = () => {
    if (!requestId || !requestAmount || !requestDate) {
      return null;
    }
    return (
      <StatusByRequestLimitCallout
        requestId={requestId}
        requestAmount={requestAmount}
        originalRequestAmount={originalRequestAmount}
        setReimbursedAmount={setReimbursedAmount}
        className={className}
      />
    );
  };

  const renderStatusByCategoryLimitCallout = () => {
    if (!expenseCategoryId || !requestDate || !requestAmount) {
      return null;
    }
    return (
      <StatusByCategoryLimitCallout
        requestAmount={requestAmount}
        requestDate={requestDate}
        currency={currency}
        expenseCategoryId={expenseCategoryId}
        className={className}
      />
    );
  };

  return (
    <>
      {shouldRenderGeneralLimitCallout && renderGeneralLimitCallout()}
      {shouldRenderStatusByRequestLimitCallout &&
        renderStatusByRequestLimitCallout()}
      {shouldRenderStatusByCategoryLimitCallout &&
        renderStatusByCategoryLimitCallout()}
    </>
  );
};
